import React from "react";
import { Link } from "react-router-dom";

import { LogoPackageHoriz } from "../../LogoPackage";

import { IMSARMBTSReport } from "../../../../types/services.interfaces/mbts-ux";

export const AnalysisFooter = ({ report }: { report: IMSARMBTSReport }) => {
    return (
        <div className="mbts_analysis__footer">
            <div className="mbts_analysis__footer__top">
                <LogoPackageHoriz />
                <p className="text-xs">Mid-Level Leadership Dashboard</p>
                <p className="text-xs">
                    <strong>
                        {report.player_current_role} ({report.player_current_level}) | {report.player_milestone_role} ({report.player_milestone_level})
                    </strong>
                </p>
            </div>
            <div className="mbts_analysis__footer__bottom">
                <p>Report by</p>
                <Link className="link link--primary" to='https://www.mindshield.org/' target="_blank">MindShield</Link>
            </div>
        </div>
    );
};